import { CommonLayout, CommonLayoutForInvestor } from '../commonComponents';
import {
    Route,
    Switch,
    useRouteMatch
} from 'react-router-dom';
import MutualFundResearch from './mutualFundResearch';
import PortfolioAnalytics from './portfolioAnalytics';
import RevenueAnalytics from './revenueAnalytics';
import { USER_ROLES } from '../../utils/constant';
import { useSelector } from 'react-redux';
import { isRMLikeRole } from '../../utils/utilityFunctions';


const routerList = [
    // {
    //     name: 'Mutual Fund Research',
    //     path: "mutual-fund-research",
    //     component: MutualFundResearch,
    // },
    {
        name: 'Portfolio Analytics',
        path: "portfolio-analytics",
        component: PortfolioAnalytics,
    },
    // {
    //     name: 'Revenue Analytics',
    //     path: "revenue-analytics",
    //     component: RevenueAnalytics,
    // },
]

function AnalyticsRoutes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            {
                routerList.map((item, index) => (
                    <Route
                        exact
                        key={index}
                        path={`${path}/${item.path}`}
                        component={item.component}
                    />
                ))
            }
        </Switch>
    );
}

export function AnalyticsRouterWrapper({ children }: any): JSX.Element {
    const { role = '' } = useSelector((state: any) => state.auth);
    return (
        isRMLikeRole(role) ?
            <CommonLayout>
                {children}
            </CommonLayout>
            :
            <CommonLayoutForInvestor>
                {children}
            </CommonLayoutForInvestor>

    )
}
export default function AnalyticsRouter(): JSX.Element {
    return (
        <>

            <AnalyticsRouterWrapper>
                <AnalyticsRoutes />
            </AnalyticsRouterWrapper>


        </>
    )
}